<app-carousel
    [typeSearch]="'Employee'"
></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <div class="mt-5">
            <div class="row">
                <div class="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12">
                    <h5 class="mt-2 mb-2">
                        <i class="fa-regular fa-square-check"></i>
                        Evaluación psicológica
                    </h5>
                    <div class="form-group mb-3" *ngFor="let item of [1,2,3]">
                        <label>¿Lorem ipsum dolor, sit amet consectetur adipisicing elit.?</label>
                        <div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" [name]="'question_' + item" [id]="'question_' + item + '1'">
                                <label class="form-check-label" [for]="'question_' + item + '1'">Si</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" [name]="'question_' + item" [id]="'question_' + item + '2'">
                                <label class="form-check-label" [for]="'question_' + item + '2'">No</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-3" *ngFor="let item of [4,5,6]">
                        <label>¿Lorem ipsum dolor, sit amet consectetur adipisicing elit.?</label>
                        <div>
                            <textarea class="form-control" rows="2"></textarea>
                        </div>
                    </div>
                    <div class="form-group mb-3" *ngFor="let item of [7,8,9]">
                        <label>¿Lorem ipsum dolor, sit amet consectetur adipisicing elit.?</label>
                        <div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" [name]="'question_' + item" [id]="'question_' + item + '1'">
                                <label class="form-check-label" [for]="'question_' + item + '1'">Si</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" [name]="'question_' + item" [id]="'question_' + item + '2'">
                                <label class="form-check-label" [for]="'question_' + item + '2'">No</label>
                            </div>
                        </div>
                    </div>
                    <hr class="mt-3 mb-3" />
                    <div class="mt-2 mb-2 text-end">
                        <button type="button" class="btn btn-secondary me-2">
                            Cancelar
                        </button>
                        <button type="button" class="btn btn-primary">
                            Guardar
                        </button>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
                    <div class="h-100 d-flex flex-column justify-content-start align-items-center">
                        <div class="wrap-circles">
                            <div class="circle" style="background-image: conic-gradient(#0d1174 35%, #eee 0);">
                                <div class="inner">35%</div>
                            </div>
                        </div>
                        <h5 class="mt-3 mb-3 text-center">
                            4 / 9 preguntas completadas del test
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>